/**
 * « Mes contrats » (`/contrats` — fiches 22087 / 22089): the page header
 * (title, breadcrumb Contrats, back to the accueil) and the configurable
 * contract list (`extranet.contractsListCard` — search `q`, status `etat`,
 * row click → contract detail). The body is wrapped in a
 * `RuleContextProvider` with the extranet base context.
 */

import { useParams } from 'react-router-dom';

import { RuleContextProvider } from '@components/shared/configurable';

import { PageHeader } from '../components/PageHeader';
import { ContractsListCardConfigurable as ContractsListCard } from '../components/contracts/register';
import { useExtranetBaseRuleContext } from '../contextVariables';
import { EXTRANET_PAGE_TEXT, extranetPath } from '../navigation';

export function ContractsPage() {
  const { tenantSlug } = useParams<{ tenantSlug: string }>();
  const text = EXTRANET_PAGE_TEXT.contracts;
  const ruleContext = useExtranetBaseRuleContext();

  return (
    <RuleContextProvider value={ruleContext}>
      <div data-testid="extranet-page-contracts">
        <PageHeader
          title={text.title}
          backTo={extranetPath(tenantSlug)}
          breadcrumbs={[{ key: 'contrats', label: text.breadcrumb }]}
        />
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          <ContractsListCard />
        </div>
      </div>
    </RuleContextProvider>
  );
}
